// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewDivider_cls1__+JLmJ","cls2":"PaymentViewDivider_cls2__9qdBN PaymentViewDivider_cls1__+JLmJ"};